/**
 * Formatting timestamps for display.
 *
 * All server timestamps are ISO-8601 with an offset (see the UtcDateTime note
 * in CLAUDE.md), so `new Date` parses them as the instant they are, and the
 * browser renders in the reader's own zone.
 */

/** "just now" / "12 min ago" / "5 h ago" / a date once it stops being recent. */
export function relativeTime(iso: string | null): string {
  if (!iso) return ''
  const seconds = (Date.now() - new Date(iso).getTime()) / 1000
  if (seconds < 90) return 'just now'
  if (seconds < 5400) return `${Math.round(seconds / 60)} min ago`
  if (seconds < 172_800) return `${Math.round(seconds / 3600)} h ago`
  return new Date(iso).toLocaleDateString()
}

/** Full date and time, for the audit log where the exact moment is the point. */
export function exactTime(iso: string): string {
  return new Date(iso).toLocaleString()
}
